import { DynaVault } from '../../../../api/DynaVaultsAPI';
import { getVaultAPYDisplay } from 'structure/pv2/vault/utils/vault';
import { Body2 } from 'components/Typography';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import * as React from 'react';

export const VaultAPY = (props: { vault: DynaVault; className?: string }) => {
  const { vault, className } = props;

  const {
    value: apy,
    prefix: apyPrefix,
    label: apyLabel,
  } = getVaultAPYDisplay(vault);

  return (
    <Body2
      className={twMerge(
        cx(
          'text-white',
          {
            'text-green': apy > 0,
            'text-white': apy <= 0,
          },
          className
        )
      )}
    >
      {apyPrefix}
      {apyLabel}
    </Body2>
  );
};
